export default "__VITE_ASSET__DXKpw18W__"